import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Auth } from 'aws-amplify';
import { environment } from '../../../environments/environment';
import { TokenStorageService } from './token.service';
@Injectable({ providedIn: 'root' })

export class AuthGuardService implements CanActivate {
  userObj: any;
  token: string = ''
  constructor(private tokenStorage: TokenStorageService,private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (environment.production) {
      // let session = await Auth.currentSession();
      let checkSession = this.tokenStorage.getToken()
      // if (checkSession) {
      //   var idTokenExpire = session.getIdToken().getExpiration();
      //   var refreshToken = session.getRefreshToken();
      //   var currentTimeSeconds = Math.round(+new Date() / 1000);
      //   if (idTokenExpire < currentTimeSeconds) {
      //     let res = await Auth.currentAuthenticatedUser();
      //     if (res) {
      //       let refresh = await res.refreshSession(refreshToken);
      //       console.log('@refresh in authguard:',refresh)
      //       if (refresh) {
      //         this.token = "Bearer " + refresh.getIdToken().getJwtToken();
      //         this.tokenStorage.saveToken(this.token);
      //       }
      //       else {
      //         Auth.signOut()
      //       }
      //       return true
      //     }
      //   }
      //   else {
      //     this.token = "Bearer " + session.getIdToken().getJwtToken();
      //     return true
      //   }
      // }
      if (checkSession) {
        return true;
      }
      else {
        this.router.navigate(['/login']);
        return false;
      }
    // }
    // else{
    //   return true
    // }
  }
}